export default __webpack_public_path__ + "static/media/home-CA-bg.809a1609.jpg";